'use client';

import React from 'react';
import { useTranslation } from '@/contexts/TranslationContext';
import VehicleCard from './VehicleCard';

const FeaturedVehicles = () => {
  const { t } = useTranslation();

  const vehicles = [
    {
      id: '1',
      name: 'Dacia Logan 2025',
      category: 'Sedan Economic',
      image: '/assets/images/dacia_logan_two_thousand_twenty_five.png',
      pricePerDay: 35,
      rating: 4.8,
      reviewCount: 124,
      features: ['5 Locuri', 'Aer Condiționat', 'Transmisie Manuală'],
      available: true,
    },
    {
      id: '2',
      name: 'CFMoto Sunset',
      category: 'SUV Premium',
      image: '/assets/images/dacia_logan_cfmoto_sunset_scenic.png',
      pricePerDay: 65,
      rating: 4.9,
      reviewCount: 89,
      features: ['7 Locuri', 'AWD', 'Pilot Automat'],
      available: true,
    },
    {
      id: '3',
      name: 'Dacia Logan Sunset Edition',
      category: 'Sedan Comfort',
      image: '/assets/images/dacia_logan_two_thousand_twenty_five_sunset.png',
      pricePerDay: 45,
      rating: 4.7,
      reviewCount: 156,
      features: ['5 Locuri', 'Navigație GPS', 'Bluetooth'],
      available: true,
    },
  ];

  return (
    <section data-component-id="src/app/homepage/components/FeaturedVehicles.tsx:47:4" data-component-path="src/app/homepage/components/FeaturedVehicles.tsx" data-component-line="47" data-component-end-line="64" data-component-file="FeaturedVehicles.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20bg-background%22%7D" className="py-16 bg-background">
      <div data-component-id="src/app/homepage/components/FeaturedVehicles.tsx:48:6" data-component-path="src/app/homepage/components/FeaturedVehicles.tsx" data-component-line="48" data-component-end-line="63" data-component-file="FeaturedVehicles.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20md%3Apx-6%20lg%3Apx-8%22%7D" className="container mx-auto px-4 md:px-6 lg:px-8">
        <div data-component-id="src/app/homepage/components/FeaturedVehicles.tsx:49:8" data-component-path="src/app/homepage/components/FeaturedVehicles.tsx" data-component-line="49" data-component-end-line="56" data-component-file="FeaturedVehicles.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-12%22%7D" className="text-center mb-12">
          <h2 data-component-id="src/app/homepage/components/FeaturedVehicles.tsx:50:10" data-component-path="src/app/homepage/components/FeaturedVehicles.tsx" data-component-line="50" data-component-end-line="52" data-component-file="FeaturedVehicles.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20md%3Atext-4xl%20font-headline%20font-bold%20text-foreground%20mb-4%22%7D" className="text-3xl md:text-4xl font-headline font-bold text-foreground mb-4">
            {t('Vehicule Recomandate')}
          </h2>
          <p data-component-id="src/app/homepage/components/FeaturedVehicles.tsx:53:10" data-component-path="src/app/homepage/components/FeaturedVehicles.tsx" data-component-line="53" data-component-end-line="55" data-component-file="FeaturedVehicles.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20text-muted-foreground%20font-body%20max-w-2xl%20mx-auto%22%7D" className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            {t('Vehicule premium selectate pentru călătoria ta perfectă')}
          </p>
        </div>

        <div data-component-id="src/app/homepage/components/FeaturedVehicles.tsx:58:8" data-component-path="src/app/homepage/components/FeaturedVehicles.tsx" data-component-line="58" data-component-end-line="62" data-component-file="FeaturedVehicles.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-8%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {vehicles?.map((vehicle) => (
            <VehicleCard data-component-id="src/app/homepage/components/FeaturedVehicles.tsx:60:12" data-component-path="src/app/homepage/components/FeaturedVehicles.tsx" data-component-line="60" data-component-end-line="60" data-component-file="FeaturedVehicles.tsx" data-component-name="VehicleCard" data-component-content="%7B%22elementName%22%3A%22VehicleCard%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" key={vehicle?.id} {...vehicle} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedVehicles;